/* Product page: swipe gallery with thumbs and zoom, and the spec side by side against a sibling sprayer.
   Add to cart, variants and the sticky bar stay in theme.js. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Gallery */
  $$('[data-pdp-gallery]').forEach((g) => {
    const track = $('[data-pg-track]', g);
    if (!track) return;
    const slides = $$('.pg__slide', track);
    const thumbs = $$('[data-pg-go]', g);
    const idxEl = $('[data-pg-index]', g);
    let idx = 0;
    const go = (i, smooth = true) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    const mark = (i) => {
      idx = i;
      if (idxEl) idxEl.textContent = i + 1;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      const t = thumbs[i];
      if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.pgGo))));
    const prev = $('[data-pg-prev]', g); const next = $('[data-pg-next]', g);
    if (prev) prev.addEventListener('click', () => go(idx - 1));
    if (next) next.addEventListener('click', () => go(idx + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });
    // Variant with its own image: theme.js clicks the matching thumb; also honour ?variant on load
    const cur = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
    if (cur > 0) go(cur, false);

    /* Zoom */
    const dlg = g.parentElement.querySelector('[data-pg-zoom]');
    if (!dlg) return;
    const ztrack = $('[data-pg-zoom-track]', dlg);
    const zslides = $$('.pg-zoom__slide', dlg);
    const open = (i) => {
      dlg.showModal();
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => { ztrack.scrollLeft = zslides[i].offsetLeft; });
    };
    $$('[data-pg-zoom-open]', g).forEach((b) => b.addEventListener('click', () => open(Number(b.dataset.pgZoomOpen))));
    $('[data-pg-zoom-close]', dlg).addEventListener('click', () => dlg.close());
    dlg.addEventListener('close', () => {
      document.body.style.overflow = '';
      $$('.is-zoomed', dlg).forEach((s) => s.classList.remove('is-zoomed'));
      const i = Math.round(ztrack.scrollLeft / Math.max(1, ztrack.clientWidth));
      go(i, false);
    });
    zslides.forEach((s) => {
      const img = $('img', s);
      const pan = (e) => {
        const r = s.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      };
      s.addEventListener('click', (e) => { pan(e); s.classList.toggle('is-zoomed'); });
      s.addEventListener('pointermove', (e) => { if (s.classList.contains('is-zoomed') && e.pointerType === 'mouse') pan(e); });
    });
  });

  /* What you need: show all in a group */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-need-more]');
    if (!b) return;
    const g = b.closest('[data-need-group]');
    const open = g.classList.toggle('is-clamped') === false;
    b.setAttribute('aria-expanded', String(open));
    if (!b.dataset.label) b.dataset.label = b.textContent;
    b.textContent = open ? 'Show fewer' : b.dataset.label;
  });

  /* Spec side by side */
  $$('[data-pdp-specs]').forEach((sec) => {
    const sel = $('[data-specs-sibling]', sec);
    const dataEl = $('[data-specs-siblings]', sec);
    if (!sel || !dataEl) return;
    let sibs = [];
    try { sibs = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const table = $('[data-specs-table]', sec);
    const head = $('[data-sib-head]', table);
    const tip = (s) => parseFloat(String(s || '').replace(/[^0-9.]/g, ''));
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    // Same rules as snippets/pdp-specs.liquid: flow keeps L/min and drops the gpm after it; pressure reads psi first,
    // converted from the bar figure (snippets/pressure-psi.liquid: 1 bar = 14.5038 psi, nearest 50 psi from 1000 up, else 10).
    const metricOnly = (v) => {
      if (typeof v !== 'string' || !v.includes(' · ')) return v;
      const [first, ...rest] = v.split(' · '); const tail = rest.join(' · ');
      if (/L\/min/.test(first) && /gpm/.test(tail)) return first;
      return v;
    };
    const psiFirst = (v) => {
      if (typeof v !== 'string') return v;
      const m = v.split(' · ')[0].match(/^\s*(\d+(?:\.\d+)?)(?: to (\d+(?:\.\d+)?))? bar\b/);
      if (!m) return v;
      const psi = (b) => { const p = parseFloat(b) * 14.5038; const step = p >= 1000 ? 50 : 10; return Math.round(p / step) * step; };
      // Non-breaking spaces inside each half (as in pressure-psi.liquid): a narrow cell wraps only before the bracket.
      const out = m[2] ? `${psi(m[1])} to ${psi(m[2])} psi (${m[1]} to ${m[2]} bar)` : `${psi(m[1])} psi (${m[1]} bar)`;
      return out.replace(/ /g, '\u00a0').replace('\u00a0(', ' (');
    };
    const cellValue = (label, v) => (/pressure/i.test(label) && !/sound/i.test(label) ? psiFirst(v) : metricOnly(v));
    // Both comparison views read the same active founder_note entries from compare-tray.
    const founder = $('[data-pdp-founder]', sec);
    const founderBody = $('[data-pdp-founder-body]', sec);
    const showFounder = (sibling) => {
      if (!founder || !founderBody) return;
      let notes = [];
      try { notes = JSON.parse(document.querySelector('[data-founder-notes]')?.textContent || '[]'); } catch (_) { /* no valid notes */ }
      const handles = [sec.dataset.productHandle, sibling?.handle];
      const note = sibling && Array.isArray(notes) && notes
        .filter((n) => n && n.note && Array.isArray(n.handles) && handles.every((h) => h && n.handles.includes(h)))
        .sort((a, b) => a.handles.length - b.handles.length)[0];
      founder.hidden = !note;
      if (!note) { founder.open = false; founderBody.replaceChildren(); delete founder.dataset.note; return; }
      const key = JSON.stringify(note);
      if (founder.dataset.note === key) return;
      founder.open = false;
      founder.dataset.note = key;
      const paras = String(note.note).trim().split(/\n\s*\n/).map((p) => `<p>${esc(p.trim()).replace(/\n/g, '<br>')}</p>`).join('');
      founderBody.innerHTML = `${note.headline ? `<p class="pdp-founder__headline">${esc(note.headline)}</p>` : ''}${paras}<p>${esc(note.author || 'Jacob')}</p>`;
    };
    const show = (handle) => {
      const s = sibs.find((x) => x.handle === handle);
      showFounder(s);
      table.classList.toggle('has-sib', !!s);
      head.hidden = !s;
      $$('.spec-tbl__sib', table).forEach((c) => { c.hidden = !s; });
      if (!s) return;
      head.innerHTML = `<a href="${esc(s.url)}">${esc(s.title)}</a>`;
      $$('tbody tr', table).forEach((tr) => {
        const label = tr.dataset.row;
        const cell = tr.querySelector('.spec-tbl__sib');
        let val = null;
        if (label === '__price') val = s.price;
        else { const r = (s.specs || []).find((x) => x.label === label); val = r ? cellValue(label, r.value) : null; }
        const mine = tr.children[1].textContent.trim();
        cell.innerHTML = val == null ? '<span class="spec-tbl__na">Not listed</span>' : esc(val);
        tr.classList.toggle('is-diff', val != null && String(val).trim() !== mine && !/part number/i.test(label));
      });
    };
    sel.addEventListener('change', () => show(sel.value));

    // These handhelds are the direct material-compatibility comparison.
    const handheldPair = {
      'graco-ultra-cordless-handheld-dewalt-18v-kit': 'graco-ultra-max-cordless-handheld-dewalt-18v-kit',
      'graco-ultra-max-cordless-handheld-dewalt-18v-kit': 'graco-ultra-cordless-handheld-dewalt-18v-kit',
    };
    const preferred = sibs.find((s) => s.handle === handheldPair[sec.dataset.productHandle]);
    if (preferred) { sel.value = preferred.handle; show(preferred.handle); return; }

    // Default: the next size up by max tip, else the nearest below
    const me = tip(sec.dataset.maxTip);
    if (!Number.isNaN(me)) {
      const withTip = sibs.filter((s) => !Number.isNaN(tip(s.max_tip)));
      const up = withTip.filter((s) => tip(s.max_tip) > me).sort((a, b) => tip(a.max_tip) - tip(b.max_tip))[0];
      const down = withTip.filter((s) => tip(s.max_tip) <= me).sort((a, b) => tip(b.max_tip) - tip(a.max_tip))[0];
      const pick = up || down;
      if (pick) { sel.value = pick.handle; show(pick.handle); }
    }
  });
})();
